import { useAppDispatch } from 'hooks/redux';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import Typography from '@mui/material/Typography';
import StdDialog from 'components/Dialogs/StdDialog';
import StdDialogActions from 'components/Dialogs/StdDialogActions';
import StdDialogContent from 'components/Dialogs/StdDialogContent';

import { rootUiActions } from 'app-components/flux/root-ui';
import { transactionRulesActions } from 'app-components/flux/transaction-rules/transactionRulesSlice';
import { tracker } from 'app-components/utils/core';
// import { tracker } from 'app-components/utils/core';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  dialog: {
    '.MuiButton-root': {
      padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
      '&.MuiButton-colorError': {
        background: theme.palette.background.paper,
        color: theme.palette.error.main,
        border: `1px solid ${theme.palette.error.main}`,
      },
    },
  },
}));

type DeleteTransactionRuleProps = {
  ruleId: string;
  source: string;
  onDelete?: () => void;
};

function DeleteTransactionRule(props: DeleteTransactionRuleProps) {
  const { classes } = useStyles();
  const { ruleId, source, onDelete } = props;
  const appDispatch = useAppDispatch();
  const dispatch = useDispatch();

  const deleteMessage =
    'Removing rules will not change existing transactions. It will only delete this rule so that future transactions cannot be affected.';

  const deleteRule = () => {
    // tracker.track(tracker.events.deleteRule);
    appDispatch(transactionRulesActions.delete(ruleId));
    tracker.track(tracker.events.txnRuleDeleted, { source });
    dispatch(rootUiActions.removeDialog());
    onDelete && onDelete();
  };

  const onClose = useCallback(() => dispatch(rootUiActions.removeDialog('delete-transaction-rule-dialog')), [dispatch]);

  return (
    <StdDialog classes={{ root: classes.dialog }} onClose={onClose} open showCloseButton size='xs' title='Delete Rule'>
      <StdDialogContent>
        <Typography variant='titleMedium'>{deleteMessage}</Typography>
      </StdDialogContent>
      <StdDialogActions
        primary={{
          id: 'delete-rule-button',
          children: 'Delete rule',
          color: 'error',
          onClick: deleteRule,
        }}
        secondary={{
          id: 'delete-rule-cancel-button',
          onClick: onClose,
        }}
      />
    </StdDialog>
  );
}

DeleteTransactionRule.displayName = 'DeleteTransactionRule';

export default DeleteTransactionRule;
